import { PaginationHeader } from "./paginationHeader";

export class PaginatedResponse<T> { //' PaginatedResult  //' class to create an new instance and passing values to the contractor | new PaginatedResponse(response.data, JSON.parse(pagination)); 
    constructor(dataArray: T, paginationHeader: PaginationHeader) {
        this.dataArray = dataArray;
        this.paginationHeader = paginationHeader;
    } 

    dataArray: T;
    paginationHeader: PaginationHeader;
}
